import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/ui/app/(public)/auth/inscription-cfa/InscriptionCfaClient.tsx");
